import React, { useState, useEffect } from 'react';
import { motion } from 'motion/react';
import { Button } from '../ui/button';

export function CookieConsentBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50"
    >
      <div className="bg-background border border-border/50 rounded-lg p-4 shadow-lg">
        <p className="text-sm text-muted-foreground mb-3">
          We use cookies to analyze website traffic and improve user experience. 
          Data collected is anonymous and used only for aggregate analytics. 
          By continuing to browse, you agree to our{' '}
          <a href="/privacy" className="text-primary hover:underline">Privacy Policy</a>.
        </p>
        <Button
          size="sm"
          onClick={handleAccept}
          className="w-full hover:scale-[1.02] transition-transform duration-200"
        >
          Got it
        </Button>
      </div>
    </motion.div>
  );
}
